import React, { useState } from 'react';

import { Stack, Tooltip, Typography, ClickAwayListener } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled, alpha, useTheme } from '@mui/material/styles';
import * as Keywords from 'src/contexts/keywords';
import Iconify from 'src/components/iconify';

function KeywordToolTip({ text, keyword, placement = 'top' }) {
  const theme = useTheme();
  const data = Keywords.find(keyword ?? text)?.[0];
  const { id, shortDescription, longDescription } = data ?? {};
  const [open, setOpen] = useState(false);

  if (!data) return keyword;

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleClick();
    }
  };

  const handleClickAway = () => {
    if (open) {
      setOpen(false);
    }
  };

  return (
    <span>
      <StyledTooltip
        open={open}
        onClose={() => setOpen(false)}
        placement={placement}
        onClick={(event) => {
          event.stopPropagation();
        }}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        title={
          <Stack padding={2} spacing={1}>
            <Typography color="text.primary" variant="h6">
              {id || 'Definition not found'}
            </Typography>
            <Typography variant="body2" color="text.primary">
              {shortDescription || 'Definition not found'}
            </Typography>
            <Typography color="text.secondary" variant="caption">
              {longDescription || ''}
            </Typography>
          </Stack>
        }
      >
        <span>
          {text ?? keyword}
          <sup>
            <ClickAwayListener onClickAway={handleClickAway}>
              <Iconify
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                role="button"
                tabIndex="0"
                icon="material-symbols:info-outline"
                sx={{ cursor: 'pointer', height: 15, color: theme.palette.info.dark }}
              />
            </ClickAwayListener>
          </sup>
        </span>
      </StyledTooltip>
    </span>
  );
}

// Define your custom styles within the styled component
const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: alpha(theme.palette.background.paper, 0.5),
    backdropFilter: `blur(${10}px)`,
    boxShadow: theme.customShadows.dropdown,
    borderRadius: theme.shape.borderRadius * 1.05,
  },
}));

export default KeywordToolTip;
